<form class="form-material m-t-10 row" [formGroup]="questionTextForm">
  <div class="form-group col-12 answer-even-input">
    <input
      *ngFor="let item of titlePropertiesArray; let i = index"
      tooltip="This field is required and must be longer then 1 letter"
      [isOpen]="canShowFormControlError(item)"
      container="body"
      [placeholder]="placeholderArray[i]"
      #pop="bs-tooltip"
      triggers=""
      placement="bottom"
      [formControlName]="item"
      class="form-control m-b-10"
      containerClass="error-tooltip"
      [id]="item"
      type="text"
    />
  </div>
</form>
